export const filterDatesOptions = [
  { value: 15, label: "15 días" },
  { value: 30, label: "1 mes" },
  { value: 60, label: "2 meses" },
  { value: 90, label: "3 meses" },
];
